import { FunctionComponent } from "react";
import classNames from "classnames";

type ToggleButtonProps = {
  value?: boolean;
  label?: string;
  onInput?: (value: boolean) => void;
};

/**
 * An on/off switch that reads as one.
 *
 * `aria-pressed` and the accent fill, rather than the local `useState` this used to
 * keep: the state lives in preferences, and a copy of it here meant the button and the
 * thing it controlled could disagree after a reload.
 */
export const ToggleButton: FunctionComponent<ToggleButtonProps> = ({
  value = false,
  label = "",
  onInput,
}) => {
  return (
    <button
      type="button"
      aria-pressed={value}
      onClick={() => onInput?.(!value)}
      className={classNames(
        "h-7 shrink-0 rounded-md border px-2.5 text-micro font-medium",
        "cursor-pointer transition-colors",
        "focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-accent",
        value
          ? "border-transparent bg-accent text-accent-ink"
          : "border-line-strong bg-surface-raised text-ink-muted hover:text-ink"
      )}
    >
      {label}
    </button>
  );
};
